// extracted by mini-css-extract-plugin
export default {"container":"DoctorBio_container__WBrzA","image":"DoctorBio_image__pZ71o","name":"DoctorBio_name__al9hI","bio":"DoctorBio_bio__JD3WQ"};